const NODE_ENV = window?.SERVER_DATA?.ENVIRONMENT || process.env.NODE_ENV
const REACT_APP_AUTH_DOMAIN =
  window?.SERVER_DATA?.AUTH_DOMAIN || process.env.REACT_APP_AUTH_DOMAIN
const REACT_APP_AUTH_CLIENT_ID =
  window?.SERVER_DATA?.AUTH_CLIENT_ID || process.env.REACT_APP_AUTH_CLIENT_ID
const REACT_APP_AUTH_AUDIENCE =
  window?.SERVER_DATA?.AUTH_AUDIENCE || process.env.REACT_APP_AUTH_AUDIENCE
const REACT_APP_BACKEND_REST_URL =
  window?.SERVER_DATA?.BACKEND_REST_URL ||
  process.env.REACT_APP_BACKEND_REST_URL

const AUTH0_CACHE_LOCATION = 'localstorage'
const AUTH_DIALOG_URL =
  NODE_ENV === 'development'
    ? 'https://localhost:3000/authdialog.html'
    : `${window.location.origin}/wordaddin/authdialog.html`
const FILE_PREVIEWER_URL =
  NODE_ENV === 'development'
    ? 'https://localhost:3000/filepreviewer.html'
    : `${window.location.origin}/wordaddin/filepreviewer.html`

const EVENT_KIND = 'HARVEY_FOR_WORD'

const HIGHLIGHT_COLOR = '#1452f133'
const MIN_HIGHLIGHT_CHARACTER_LENGTH = 50
const MAX_HIGHLIGHT_CHARACTER_LENGTH = 5000
const DEFAULT_DOCUMENT_INSTRUCTION =
  'Revise the highlighted text to align with the related content from the selected source files.'
const NO_HIGHLIGHTED_TEXT_DESCRIPTION = 'No text selected'
const HIGHLIGHTED_TEXT_DESCRIPTION = 'Selected clause'
const LOCK_TOOLTIP =
  'The highlighted text is locked. Unlock by resetting or clicking the lock icon.'
const NEW_HIGHLIGHT_DESCRIPTION =
  'Would you like to reset to generate new suggestions?'
const PLACEHOLDER_REVISE = 'Ask Harvey to revise the selection…'
const PLACEHOLDER_INSERT = 'Ask Harvey to draft something new…'

enum DialogStatus {
  success = 'success',
  error = 'error',
}

enum DialogRequestType {
  suggestions = 'suggestions',
}

enum TaskpaneResponseType {
  accessToken = 'accessToken',
  textWithReferences = 'textWithReferences',
}

enum RequestMode {
  INSERT = 'insert',
  EDIT = 'edit',
  REVISE = 'revise',
}

export {
  // Auth Constants
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_AUTH_CLIENT_ID,
  REACT_APP_AUTH_AUDIENCE,
  REACT_APP_BACKEND_REST_URL,
  AUTH0_CACHE_LOCATION,
  AUTH_DIALOG_URL,
  FILE_PREVIEWER_URL,
  EVENT_KIND,

  // Edit Constants
  HIGHLIGHT_COLOR,
  MIN_HIGHLIGHT_CHARACTER_LENGTH,
  MAX_HIGHLIGHT_CHARACTER_LENGTH,
  DEFAULT_DOCUMENT_INSTRUCTION,
  NO_HIGHLIGHTED_TEXT_DESCRIPTION,
  HIGHLIGHTED_TEXT_DESCRIPTION,
  LOCK_TOOLTIP,
  NEW_HIGHLIGHT_DESCRIPTION,
  PLACEHOLDER_REVISE,
  PLACEHOLDER_INSERT,

  // types
  DialogStatus,
  DialogRequestType,
  RequestMode,
  TaskpaneResponseType,
}
